import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import Icon from "../Icon/Icon";
import TableHeaderColumn from "./TableHeaderColumn";
import "./Table.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TableSortableHeaderColumn = _ref => {
  let {
    children,
    className = '',
    colName,
    sortBy,
    sortDirection,
    setSort,
    label,
    style = {}
  } = _ref;
  const isSorted = sortBy === colName;
  const onColClick = () => {
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSort({
      sortBy: colName,
      sortDirection: newDirection
    });
  };
  return /*#__PURE__*/_jsx(TableHeaderColumn, {
    className: className,
    "aria-sort": sortDirection === 'asc' ? 'ascending' : 'descending',
    style: style,
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: onColClick,
      className: "p-2 -m-2 flex uppercase items-center",
      "aria-label": `Sort by ${label} in ${sortDirection === 'asc' ? 'ascending' : 'descending'} order`,
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex-none font-heavy-font",
        children: children
      }), /*#__PURE__*/_jsx("div", {
        className: cn('flex-none ml-2', {
          'opacity-50': !isSorted
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-center",
          children: [/*#__PURE__*/_jsx(Icon, {
            icon: "ChevronArrow",
            size: 10,
            direction: sortDirection === 'asc' && isSorted ? 'down' : 'up',
            className: "transform flex-none text-text-blue fill-current"
          }), !isSorted && /*#__PURE__*/_jsx(Icon, {
            icon: "ChevronArrow",
            size: 10,
            className: "-mt-3px text-text-blue fill-current",
            direction: "down"
          })]
        })
      })]
    })
  });
};
TableSortableHeaderColumn.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  colName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  setSort: PropTypes.func.isRequired,
  style: PropTypes.object
};
export default TableSortableHeaderColumn;
//# sourceMappingURL=TableSortableHeaderColumn.js.map